import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { setActiveConnection, unsetActiveConnection, fetchIndirectCases, selectCase } from '../../redux/actions'
import { getCurrentUser } from '../../redux/selectors'
import { getActiveConnectionDataFromClickedListItem } from '../ConnectionForm/utils'
import { StatusBadge } from '../../CaseStatus'
import { RELATION, USER_OTHER_CONNECTION, RELATION_OTHER_CONNECTION } from '../../connectionTypes'
import editDocument from '../../icons/edit_document.svg'
import { ReactComponent as PublicInfoIcon } from '../../icons/building-columns-solid.svg'
import ItemRemarks from './ItemRemarks'
import GoToCase from './GoToCase'
import OpenForm from './OpenForm'
import I18n, {useI18nFunction} from '../I18n'
import ListItemPlaceholder from './ListItemPlaceholder'

const ListItem = ({
  hasConfirmedNoConnections,
  itemIsApplication,
  draft,
  Case,
  checked,
  image,
  title,
  description,
  small,
  connectionType,
  active,
  setActiveConnection,
  unsetActiveConnection,
  from,
  isCurrentUsersProfile,
  relation,
  fetchIndirectCases,
  userId,
  selectCase
}) => {
  const I18nFunction = useI18nFunction();

  let disabledInteraction = false
  if (!isCurrentUsersProfile || itemIsApplication) disabledInteraction = true

  const isRelationOrOther = [RELATION, USER_OTHER_CONNECTION, RELATION_OTHER_CONNECTION].includes(connectionType)

  const onClick = (e) => {
    relation ? selectCase(relation) : selectCase(Case)
    if (!isRelationOrOther) {
      fetchIndirectCases(Case?.id)
    }
    if (!checked) {
      autoSetActiveConnection()
    }
  }

  const autoSetActiveConnection = (e) => {
    const activeConnectionData = getActiveConnectionDataFromClickedListItem(
      Case,
      relation,
    )
    unsetActiveConnection()
    active
      ? unsetActiveConnection()
      : setActiveConnection({
        id: activeConnectionData.id,
        caseId: relation ? undefined : Case?.id,
        relationId: Case?.relationId,
        connectionType: connectionType,
        connection: activeConnectionData,
      })
  }

  if (draft) {
    return <ListItemPlaceholder 
      icon={editDocument}
      title={I18nFunction( {id:'connection_list_item.description' })}
      description={I18nFunction({id:'connection_list_item.new_relationship'})}
    />
  }
  return (
    <Wrapper
      className={[
        active && 'active',
        !checked && 'attention',
        disabledInteraction && 'disabledInteraction',
      ]}
    >
      {(Case?.userPublicDataRole || Case?.userPublicDataOwnership) && (
        <PublicInfoIcon
          style={{
            position: 'absolute',
            stroke: '#ccc',
            fill: '#ccc',
            width: '1em',
            height: '1em',
            top: '0.1em',
            left: '1.5em',
          }}
          title={<I18n id='case_details.public' />}
        />
      )}
      {image && <Icon src={image} alt="" />}
      <Content>
        <Title small={small} title={title}>
          {title}
        </Title>
        <Subtitle>
          <Description small={small} description={description}>
            {description}
          </Description>
        </Subtitle>
      </Content>
      <FromWrapper>
        {from === undefined ? (
          ''
        ) : (
          <From>
            <I18n id="Updated" />
            <div>{from}</div>
          </From>
        )}
      </FromWrapper>
      <RightFlexBox>
        <StatusWrapper>
          <StatusBadge status={Case?.status} />
        </StatusWrapper>
        <MarkerWrapper>
          <ItemRemarks Case={Case} confirmed={checked} />
        </MarkerWrapper>
        <Buttons>
          {!relation && (checked || !isCurrentUsersProfile) && <GoToCase caseId={Case?.id} />}
          {!itemIsApplication && <OpenForm onClick={onClick} />}
        </Buttons>
      </RightFlexBox>
    </Wrapper>
  )
}

const RightFlexBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 49%;
`

const StatusWrapper = styled.div`
  display: flex;
`

const MarkerWrapper = styled.div`
  margin-left: auto; 
  margin-right: 0;
`

const Buttons = styled.div`
  display: flex;
  margin-left: auto; 
  margin-right: 0;
  gap: 0.2em;
  padding: 0em 0.5em;
`

const Wrapper = styled.div`
  box-shadow: rgb(219 219 219) 0px 2px 8px;
  border-radius: 5px;
  position: relative;
  background-color: ${({ theme }) => theme.primaryBackground};
  display: flex;
  align-items: center;
  padding: 0.8em 1em;
  margin: 0.3em;
  border: solid 2px ${({ theme: { primaryBackground } }) => primaryBackground};

  &.active {
    border-color: ${({ theme: { primary } }) => primary};
  }
  &.attention {
    box-shadow: rgb(180 180 200) 0px 2px 8px;
  }
  &.disabledInteraction {
    cursor: default;
  }
`

const Content = styled.div`
  flex-grow: 1;
  overflow: hidden;
  white-space: nowrap;
  width: 33%;
  padding-right: 0em;
`

const Title = styled.div`
  font-size: ${({ small, theme: { normalText, largeText } }) =>
    small ? normalText : largeText};
  ${({ title, theme: { secondary } }) => !title && 'color: ' + secondary}
  margin-bottom: 0.2em;
  overflow: hidden;
  text-overflow: ellipsis;
`

const Subtitle = styled.div`
  display: flex;
  flex-direction: row;

`

const Description = styled.span`
  ${({ description, small, theme: { secondary, subtleText } }) =>
    !description ? 'color: ' + secondary : small && 'color: ' + subtleText}
  overflow: hidden;
  text-overflow: ellipsis;
`

const From = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 0.825em;
  align-items: center;
  justify-content: center;
`

const FromWrapper = styled.div`
  width: 12%;
`

const Icon = styled.img`
  margin-right: 1.5em;
  height: 2em;
  width: 2em;
  flex-shrink: 0;
`

const mapStateToProps = (state, props) => {
  const userId = getCurrentUser(state).id
  return {
    userId: userId
  }
}

const mapDispatchToProps = { setActiveConnection, unsetActiveConnection, fetchIndirectCases, selectCase }

export default connect(mapStateToProps, mapDispatchToProps)(ListItem)
